import React from 'react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Image from '@atlaskit/image';
import { xcss, Box } from '@atlaskit/primitives';
import type { reportImage_reportsOverviewPage$key } from '@atlassian/jira-relay/src/__generated__/reportImage_reportsOverviewPage.graphql';
import { IMAGE_WIDTH, IMAGE_HEIGHT } from '../../common/constants.tsx';
import { getImageForKey } from './utils.tsx';

export const ReportImage = ({
	report,
}: {
	report: reportImage_reportsOverviewPage$key;
}): React.JSX.Element => {
	const reportData = useFragment<reportImage_reportsOverviewPage$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment reportImage_reportsOverviewPage on JiraReport {
				key @required(action: THROW)
				name @required(action: THROW)
				imageUrl
			}
		`,
		report,
	);

	const key = reportData.key;
	const name = reportData.name;
	const url = reportData.imageUrl;

	if (url) {
		return (
			<Box xcss={imageStyles}>
				<Image src={url} width={IMAGE_WIDTH} height={IMAGE_HEIGHT} alt={name} />
			</Box>
		);
	}
	return <Box xcss={imageStyles}>{getImageForKey(key, name)}</Box>;
};

const imageStyles = xcss({
	height: '144px',
	overflow: 'hidden',
});
